import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle, ArrowLeft, Calendar, Home } from 'lucide-react';
import translations from '../contexts/translations';

const ReservationCancelPage = ({ language }) => {
  const t = translations[language];

  return (
    <div className="min-h-screen bg-gray-50 pt-28 pb-16 px-6 sm:px-8 flex flex-col items-center justify-center">
      <div className="max-w-xl w-full">
        {/* Bannière d'annulation */}
        <div className="bg-gradient-to-r from-gray-600 to-gray-800 rounded-t-2xl p-8 text-white relative overflow-hidden">
          {/* Cercles décoratifs */}
          <div className="absolute -top-12 -right-12 w-40 h-40 rounded-full bg-white/5"></div>
          <div className="absolute -bottom-8 -left-8 w-28 h-28 rounded-full bg-white/5"></div>
          
          <div className="relative z-10 flex flex-col sm:flex-row sm:items-center">
            <div className="mb-4 sm:mb-0 sm:mr-6 flex justify-center sm:justify-start">
              <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center">
                <XCircle className="w-10 h-10 text-gray-500" />
              </div>
            </div>
            <div className="text-center sm:text-left">
              <h1 className="text-3xl font-bold mb-2">{t.bookingCancelled || 'Réservation annulée'}</h1>
              <p className="opacity-90">{t.noPurchase || 'Aucun achat n\'a été effectué.'}</p>
            </div>
          </div>
        </div>
        
        {/* Contenu principal */}
        <div className="bg-white rounded-b-2xl shadow-lg p-8 mb-6">
          <div className="text-center mb-8">
            <p className="text-gray-600 mb-4">
              {t.cancelMessage || 'Votre réservation a été annulée. Aucun montant n\'a été débité de votre carte.'}
            </p>
            <p className="text-gray-500">
              {t.tryAgainMessage || 'Vous pouvez réessayer plus tard ou nous contacter si vous avez besoin d\'aide.'}
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/sejour" className="w-full sm:w-auto inline-flex items-center justify-center px-5 py-3 border border-gray-300 rounded-xl shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors">
              <Calendar className="w-5 h-5 mr-2 text-orange-500" /> 
              {t.backToHotels || 'Retour aux hôtels'}
            </Link>
            
            <Link to="/" className="w-full sm:w-auto inline-flex items-center justify-center px-5 py-3 border border-transparent rounded-xl shadow-sm text-sm font-medium text-white bg-gradient-to-r from-orange-500 to-red-600 hover:from-orange-600 hover:to-red-700 transition-colors">
              <Home className="w-5 h-5 mr-2" /> 
              {t.goToHomepage || 'Aller à l\'accueil'}
            </Link>
          </div>
        </div>
        
        {/* Section d'aide */}
        <div className="bg-white rounded-2xl shadow-lg p-6 mb-6">
          <h2 className="font-semibold text-gray-800 mb-2 text-center sm:text-left">{t.needHelp || 'Besoin d\'aide?'}</h2>
          <p className="text-gray-600 mb-4 text-center sm:text-left">{t.contactUs || 'N\'hésitez pas à nous contacter si vous avez des questions ou rencontrez des difficultés avec votre réservation.'}</p>
          <div className="bg-orange-50 p-4 rounded-xl border border-orange-100">
            <div className="flex items-center justify-center sm:justify-start text-orange-800 mb-3">
              <div className="bg-orange-100 p-2 rounded-lg">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
                </svg>
              </div>
              <span className="ml-3 font-medium">{t.common || 'Problèmes courants'}</span>
            </div>
            <ul className="text-sm text-gray-600 space-y-2 pl-4 sm:pl-11 list-disc">
              <li>{t.paymentIssue || 'Problème avec votre méthode de paiement'}</li>
              <li>{t.connectionIssue || 'Problème de connexion internet pendant le paiement'}</li>
              <li>{t.reservationUnavailable || 'L\'hôtel n\'est plus disponible pour les dates sélectionnées'}</li>
            </ul>
          </div>
        </div>
        
        {/* Retour à l'accueil */}
        <div className="text-center">
          <Link to="/" className="inline-flex items-center justify-center text-gray-600 hover:text-gray-800 font-medium px-6 py-2 rounded-xl hover:bg-gray-100 transition-all">
            <ArrowLeft className="w-4 h-4 mr-2" /> {t.backToHome || 'Retour à l\'accueil'}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ReservationCancelPage;